import { z } from 'zod';

export const CutawayBSchema = z.object({
    type: z.literal('cutaway-b'),
    data: z.object({
        text: z.array(z.string().max(7)).max(3),
    }),
});
export type CutawayB = z.infer<typeof CutawayBSchema>;
